export const AUTH_KEYS = {
  ACCESS_TOKEN: 'token',
  REFRESH_TOKEN: 'refresh',
};
